import { IOperationAllow, canOperate } from '../common';
import { filter as lfilter } from 'lodash/fp';

export const labels = (operations: IOperationAllow[]) =>
  lfilter<{ label: string; value: number; allow: boolean }>({ allow: true })([
    {
      label: 'Approvals',
      value: 0,
      allow: canOperate(operations)('admin'),
    },
    {
      label: 'Revocations',
      value: 1,
      allow: canOperate(operations)('admin'),
    },
    {
      label: 'Status of Requests',
      value: 2,
      allow: canOperate(operations)('admin'),
    },
    {
      label: 'Status of CSA Requests',
      value: 3,
      allow: canOperate(operations)('admin'),
    },
    {
      label: 'Legacy Revocations',
      value: 4,
      allow: canOperate(operations)('admin'),
    },
    {
      label: 'Legacy Status of Requests',
      value: 5,
      allow: canOperate(operations)('admin'),
    },
    {
      label: 'Search Users',
      value: 6,
      allow: canOperate(operations)('admin'),
    },
  ]);
